{
  "title": "Releases",
  "description": "The changelog for every version, and which version runs on each server.",
  "fleet": {
    "title": "Your servers",
    "columns": {
      "server": "Server",
      "channel": "Channel",
      "version": "Current version",
      "state": "Update",
      "checkIn": "Last check-in"
    },
    "notInstalled": "Not installed",
    "never": "Not yet",
    "empty": "No servers yet",
    "add": "Add a server",
    "state": {
      "up_to_date": "Up to date",
      "update_available": "{{version}} available",
      "security_only": "Security update {{version}}",
      "not_installed": "Waiting for install"
    },
    "howTo": "Each server updates itself from bPanel on the server: Settings, then Updates. That's where you choose automatic updates or notify only, and the channel for each server. A locked server, or one offline for a while, only receives security updates.",
    "summary_one": "1 server can update.",
    "summary_other": "{{count}} servers can update.",
    "summary_zero": "Every server is on the latest version of its channel."
  },
  "changelog": {
    "title": "Changelog",
    "filter": "Show releases",
    "all": "All",
    "latest": "Latest",
    "empty": "No releases on this channel",
    "betaNote": "Beta releases arrive weeks before stable. Try them on a staging server before production."
  },
  "groups": {
    "new": "New",
    "improved": "Improved",
    "fixed": "Fixed",
    "security": "Security"
  },
  "compat": {
    "os": "Supported systems",
    "upgradeFrom": "Updates directly from {{version}} or later.",
    "running": "Running on:"
  }
}
